import { render, staticRenderFns } from "./CustomerInput.vue?vue&type=template&id=13135a4a&scoped=true"
import script from "./CustomerInput.vue?vue&type=script&lang=js"
export * from "./CustomerInput.vue?vue&type=script&lang=js"
import style0 from "./CustomerInput.vue?vue&type=style&index=0&id=13135a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13135a4a",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
